import calculateMapUrl from '../utils/calculateMapUrl';
import { LocationPersonaControlViewState } from '../data/schema/LocationPersonaControlViewState';
import { isNullOrWhiteSpace } from 'owa-string-utils';

const minBlobSize = 100;
const defaultPhotoWidth = 64;
const defaultPhotoHeight = 64;

/**
 * Download the persona map for the specified place
 * @param viewState: the location persona control view state
 */

export default function getLocationPhoto(
    viewState: LocationPersonaControlViewState,
    onCompleteDownload: (blobUrl: string) => void
) {
    let photoUrl = '';
    if (
        viewState.postalAddress &&
        viewState.postalAddress.Latitude &&
        viewState.postalAddress.Longitude
    ) {
        photoUrl = calculateMapUrl(
            viewState.postalAddress.Latitude,
            viewState.postalAddress.Longitude,
            defaultPhotoWidth,
            defaultPhotoHeight
        );
    }

    if (!isNullOrWhiteSpace(photoUrl)) {
        let request = new XMLHttpRequest();
        request.open('GET', photoUrl, true);
        request.responseType = 'blob';
        request.onreadystatechange = function() {
            if (request.readyState === 4) {
                let blob: any = null;
                let isBlob = false;
                if (request.status === 200) {
                    blob = request.response;
                    let contentType = request.getResponseHeader('Content-Type');
                    isBlob =
                        contentType &&
                        contentType.toLowerCase().indexOf('image') == 0 &&
                        blob instanceof Blob;
                }

                let blobUrl: string;
                if (isBlob && blob && blob.size > minBlobSize) {
                    blobUrl = URL.createObjectURL(blob);
                }

                onCompleteDownload(blobUrl);
            }
        };

        request.send();
    } else {
        // complete the downloading and set request status to failed
        onCompleteDownload(null);
    }
}
